import { useState, useEffect, useCallback, useRef } from "react";
import axios from "../axios";
import { debounce, set } from "lodash";

import { useNewValue } from "../contexts/NewValue";

const useInputDebounce = ({ url, speed = 250, state = false, select = [], conditionStr = '', serverOptions, forceServer = false, onlyPrefetch = false, additionalCollections = [], initialValue }) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(serverOptions?.length ? serverOptions : []);

  const initValue = useRef(null);

  const [value, setValue] = useState("");

  const { newValue } = useNewValue() || {};

  select = select.length ? select.join(',') : "";

  useEffect(() => {
    if (serverOptions?.length) {
      setOptions(serverOptions);
    }
  }, [serverOptions]);

  useEffect(() => {
    if (newValue) {
      setOptions(opt => [...opt, newValue]);
    }
  }, [newValue]);

  useEffect(() => {
    if (initialValue) {
      if (initValue.current === JSON.stringify(initialValue)) return;
      setOptions(opt => [initialValue]);
      initValue.current = JSON.stringify(initialValue);
    }
  }, [initialValue]);

  const handleInputChange = useCallback(debounce(async val => {
    if (!url) return val;
    if ((serverOptions?.length && !forceServer) || onlyPrefetch) {
      return val;
    }

    if (!options.length) {
      setLoading(true);
    }
    if (conditionStr) {
      conditionStr = conditionStr ? `${conditionStr}` : ''
    }

    let ac = '';
    if (additionalCollections?.length) {
      ac = `&term[additionalCollections]=${additionalCollections.join(',')}`;
    }
    try {
      const {data} = await axios.get(`/${url}?term[search]=${encodeURIComponent(val)}${ac}${conditionStr}&select=${select}&limit=30`);
      setOptions(data?.rows || []);
      return val;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, speed), [serverOptions, conditionStr, onlyPrefetch, additionalCollections]);

  let config = {
    loading,
    options,
    handleInputChange
  } 

  if (state) {
    config = {
      ...config,
      value,
      setValue
    }
  }

  return config;
}

export default useInputDebounce;